import ContractSign from '@components/LocalMerchant/ContractSign'
import ContractConfirm from '@components/LocalMerchant/ContractSign/ContractConfirm'
import SuccessPage from '@components/LocalMerchant/ContractSign/SuccessPage'

export default {
  path: 'contract',
  component: ContractSign,
  childRoutes: [
    {
      path: 'confirm/:posterId',
      indexRoute: {
        component: ContractConfirm
      },
      stat: '线上合同签署'
    },
    {
      path: 'success',
      indexRoute: {
        component: SuccessPage
      },
      stat: '合同签署成功'
    }
  ]
}
